import { useState, forwardRef, useImperativeHandle, useEffect } from "react";
import { Row, Button, Space, Form } from "antd";
import "./Search.scss";
import InputFields from "../InputFields/InputFields";
import { DownOutlined, SearchOutlined, UpOutlined } from "@ant-design/icons";

const Search = forwardRef((props, ref) => {
  const [expand, setExpand] = useState(false);
  const { fields, onClickSearch, initialValues, defaultFieldsValue } = props;

  const defaultFields = fields?.filter((field) => !field.expand) || [];
  const expandFields = fields?.filter((field) => field.expand) || [];

  const [form] = Form.useForm();

  useImperativeHandle(ref, () => ({
    getData: () => {
      const allParams = form.getFieldsValue();

      return allParams;
    },
    setFieldValue: (name, value) => {
      form.setFieldValue(name, value);
    },
    resetValue: () => form.resetFields(),
  }));

  useEffect(() => {
    form.setFieldsValue({});
  }, [initialValues]);

  useEffect(() => {
    if (defaultFieldsValue) {
      defaultFieldsValue.forEach((field) => {
        form.setFieldsValue({
          [field.label]: field.value,
        });
      });
    }
  }, [JSON.stringify(defaultFieldsValue)]);

  return (
    <div className="expand-search-container" style={{ width: "100%" }}>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Form form={form} labelAlign="left">
          <Row gutter={[16, 8]}>
            <InputFields data={defaultFields} />
            {expand ? <InputFields data={expandFields} /> : undefined}
          </Row>
        </Form>
        <Row justify={"end"}>
          <Space>
            <Button
              onClick={() => setExpand(!expand)}
              className="custom-btn"
              style={{ display: props.showAdvancedSearch ? "block" : "none" }}
            >
              Tìm kiếm nâng cao
              {!expand ? <DownOutlined /> : <UpOutlined />}
            </Button>
            <Button
              htmlType="submit"
              onClick={onClickSearch}
              type="primary"
              icon={<SearchOutlined />}
            >
              Lấy danh sách
            </Button>
          </Space>
        </Row>
      </Space>
    </div>
  );
});
// })

// ({fields, onClickSearch}: PropsType) => {
export default Search;
